import React, { useState, useEffect } from "react";
import UserService from "../../services/UserService";
import { IoIosClose } from "react-icons/io";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useForm } from "react-hook-form";
import RequestService from "../../services/RequestService";
import MinorRequestDetails from './../molecules/MinorRequestDetails';
import { parseISO, format } from "date-fns";
import StatusRequests from '../../enums/StatusRequests'
import { MdSend } from "react-icons/md";
import { FaStamp } from 'react-icons/fa';

export default function SendModal({
  isModalOpen,
  setModalOpen,
  requestId,
  requestNro,
  // setTicketCb
}) {
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    getValues,
    setError,
    clearErrors,
    watch,
    formState: { errors },
  } = useForm();

  const [entregadores, setEntregadores] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const [requestObject, setRequestObject] = useState();

  const [atualizadoSGRS, setAtualizadoSGRS] = useState(false);

  const [isMultiTrecho, setIsMultiTrecho] = useState(false);

  const [showDropdown, setShowDropdown] = useState(false);

  const handleAtualizadoSGRSChange = (event) => {
    setAtualizadoSGRS(event.target.checked);
  };

  useEffect(() => {
    async function fetchRequest() {
      const request = await RequestService.getRequestById(requestId);
      setRequestObject(request);
      console.log(request?.request.idRequest);
    }

    fetchRequest();
  }, [isModalOpen, requestId]);

  useEffect(() => {
    const fetchEntregadores = async () => {
      if (searchTerm.trim() === "") {
        setEntregadores([]);
        return;
      }

      try {
        const results = await UserService.getEntregadores(searchTerm);
        setEntregadores(results);
      } catch (error) {
        console.error("Erro ao buscar entregadores:", error);
      }
    };

    const delayDebounceFn = setTimeout(() => {
      fetchEntregadores();
    }, 300); // Aguarda 300ms após o usuário parar de digitar

    return () => clearTimeout(delayDebounceFn); // Limpa o timeout anterior
  }, [searchTerm]);

  const onSubmit = async (data) => {
    const matriculaEntregador = getValues("matriculaEntregador");

    if (matriculaEntregador && !/^\d+$/.test(String(matriculaEntregador))) {
      setError("matriculaEntregador", {
        type: "manual",
        message: "Matrícula deve conter apenas números",
      });
      return;
    }

    try {
      data = {
        ...data,
        status: "ROTA DE ENTREGA"
      };

      // const response = await RequestService.updateParcial(requestId, data);
      const response = await RequestService.sendToDeliveryRoute(requestId, data);

      if (response) {
        toast.success("Pedido enviado!");

        // Saiu do depósito sem Nota de Embarque: ninguém avisou a portaria.
        // O aviso é aqui, com quem expediu ainda na frente da tela, porque é
        // o único momento em que dá tempo de gerar a Nota antes do veículo sair.
        if (response.avisoPortaria) {
          toast.warn(response.avisoPortaria + " Gere a Nota de Embarque para disparar o alerta.", {
            autoClose: 10000,
          });
        }

        setModalOpen(!isModalOpen);
        reset();
      } else {
        toast.error("Ops! Algo deu errado");
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
        error?.message ||
        "Erro inesperado ao enviar pedido."
      );
    }
  };

  const onClose = () => {
    setModalOpen(!isModalOpen);
    setAtualizadoSGRS(false);
    reset();
  };

  const handleSetMultiTrecho = (event) => {
    setIsMultiTrecho(event.target.checked);
    setValue("isMultiTrecho", event.target.checked);
    // console.log(event.target.checked)
  };

  if (isModalOpen) {
    return (
      <div
        className="flex flex-col relative z-10"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto py-8"
          onClick={onClose}
        >
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <div className="flex flex-col max-w-[700px] h-fit pb-4 relative transform rounded-lg bg-white text-left shadow-xl transition-all" onClick={(e) => e.stopPropagation()}>
              <button
                onClick={onClose}
                className="absolute -top-7 -right-7 rounded-full p-1"
              >
                <div className="w-12 h-12 flex bg-gray-200 justify-center items-center rounded-full ms-6">
                  <div className="flex justify-center items-center">
                    <IoIosClose color={"black"} size={32} />
                  </div>
                </div>
              </button>
              <div className="flex flex-col px-4 pt-4 pb-3 text-left gap-2 bg-gray-800 text-white rounded-t-lg">

                <div className="flex justify-between gap-2">
                  <div className="flex gap-2 items-center text-white text-xl font-bold">
                    <MdSend />
                  ENVIAR PARA ROTA DE ENTREGA
                  </div>

                  {requestObject?.request?.isReplica &&
                    <div>
                      <p className="text-black font-bold rounded-lg px-1 bg-yellow-300">
                        RÉPLICA SGRS
                      </p>
                    </div>
                  }
                </div>

                <div className="ms-4 flex justify-between">
                  <div className="text-sm">
                    Solicitação nº: {requestObject?.request?.idRequest}
                  </div>
                  <div className="text-sm">
                    {/* Criado em: {requestObject?.request?.createdAt } */}
                    Criado em: {requestObject && format(parseISO(requestObject?.request?.createdAt), 'dd/MM/yy HH:mm')}
                  </div>
                  <div className="flex items-center gap-2">
                    Status:
                    <p  className="text-sm text-black rounded-lg px-2"
                        style={{ backgroundColor: StatusRequests[requestObject?.request?.status]?.cor }}>
                      {requestObject?.request?.status}
                    </p>
                  </div>
                </div>
              </div>

              <MinorRequestDetails request={requestObject?.request} divContato={true}/>

              {/* MODAL FORM BEGIN */}

              <div className="flex flex-col mt-6 px-4 text-xs">
                <div className="w-full relative inline-block text-left">
                  <div className="w-full flex flex-col gap-4 px-4">

                    <div className="flex flex-col items-start gap-1 w-full relative">
                      <div className="flex w-full justify-between">
                        <label className="block text-gray-700 font-bold whitespace-nowrap">Nome Entregador:</label>
                        <div className="flex gap-1 items-center">
                          <label className="text-gray-700 whitespace-nowrap">Multi Trecho</label>
                          <input
                            id="isMultiTrecho"
                            type="checkbox"
                            checked={isMultiTrecho}
                            onChange={handleSetMultiTrecho}
                            className="form-checkbox h-4 w-4 text-blue-600"
                          />
                        </div>
                      </div>
                      {/* Campo de seleção customizado */}
                      <div className="w-full relative">
                        <input
                          type="text"
                          readOnly
                          value={watch("nomeEntregador") || ""}
                          placeholder="Selecione o entregador"
                          onClick={() => setShowDropdown(!showDropdown)}
                          className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400 cursor-pointer bg-white
        ${errors?.nomeEntregador?.type === "required"
                              ? " border border-red-500 outline-none ring-0"
                              : "border border-zinc-500 outline-none ring-0"
                            }
      `}
                        />
                        {errors?.nomeEntregador?.type === "required" && (
                          <p className="text-red-500 text-xs">Campo obrigatório</p>
                        )}
                        {showDropdown && (
                          <div className="absolute w-full top-full left-0 mt-1 max-h-52 overflow-y-auto bg-white rounded shadow-lg border border-gray-200 z-20">
                            <input
                              type="text"
                              autoFocus
                              placeholder="Buscar entregador"
                              value={searchTerm}
                              onChange={e => setSearchTerm(e.target.value)}
                              className="w-full px-4 py-1 border-b border-gray-200"
                            />
                            <ul>
                              {entregadores.map(entregador => (
                                <li
                                  key={entregador._id}
                                  onClick={() => {
                                    setValue("nomeEntregador", entregador.name, { shouldValidate: true });
                                    setValue("telefoneEntregador", entregador.phone);
                                    setValue("matriculaEntregador", entregador.reLegal, { shouldValidate: true });
                                    setValue("entregadorId", entregador._id);
                                    clearErrors("matriculaEntregador");
                                    setShowDropdown(false);
                                  }}
                                  className="px-4 py-2 cursor-pointer hover:bg-gray-100"
                                >
                                  {entregador.name} - {entregador.company.name}
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="flex flex-row gap-2 w-full">
                      <div className="flex flex-col items-start gap-1 w-1/2">
                        <label className="block text-gray-700 font-bold whitespace-nowrap">
                          Telefone Entregador:
                        </label>
                        <input
                          type="text"
                          {...register("telefoneEntregador", { required: true })}
                          // disabled={true}
                          className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
        ${errors?.telefoneEntregador?.type === "required"
                              ? " border border-red-500 outline-none ring-0"
                              : "border border-zinc-500 outline-none ring-0"
                            }
      `}
                        />
                        {errors?.telefoneEntregador?.type === "required" && (
                          <p className="text-red-500 text-xs ms-2">Campo obrigatório</p>
                        )}
                      </div>
                      <div className="flex flex-col items-start gap-1 w-1/2">
                        <label className="block text-gray-700 font-bold whitespace-nowrap">
                          Matrícula Entregador:
                        </label>
                        <input
                          type="text"
                          {...register("matriculaEntregador")}
                          disabled={true}
                          className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
        ${errors?.matriculaEntregador
                              ? " border border-red-500 outline-none ring-0"
                              : "border border-zinc-500 outline-none ring-0"
                            }
      `}
                        />
                        {errors?.matriculaEntregador && (
                          <p className="text-red-500 text-xs ms-2">{errors.matriculaEntregador.message || "Matrícula deve conter apenas números"}</p>
                        )}
                      </div>
                    </div>

                    <div className="flex flex-row gap-2 w-full">
                    
                    <div className="flex flex-col items-start gap-1 mb-4 w-full">
                      <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">Observação:</label>
                      <textarea
                        {...register("obsAtualizacao", { required: true })}
                        className={`
                              w-full h-[70px] p-4 bg-white rounded-2xl justify-start items-center inline-flex resize-none 
                              text-neutral-600 font-normal font-['Work Sans']
                              focus:border focus:border-zinc-800 focus:outline-none focus:ring-0
                              placeholder:text-neutral-400 placeholder:font-normal
                              ${
                                errors?.obsAtualizacao?.type === "required" ?
                                "border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                          }
                          `}
                        placeholder={"Observação"}>
                      </textarea>
                      {errors?.obsAtualizacao?.type === "required" && (
                        <p className="text-red-500 text-xs whitespace-nowrap">
                          Campo obrigatório
                        </p>
                      )}
                    </div>
                    <div className="flex flex-col items-start gap-1 mb-4 w-full">
                      <div className="flex gap-1 text-gray-700">
                        <FaStamp />
                        <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">Carimbo:</label>
                      </div>
                      <textarea
                        {...register("carimbo", { 
                          // required: true 
                        })}
                        className={`
                              w-full h-[70px] p-4 bg-white rounded-2xl justify-start items-center inline-flex resize-none 
                              text-neutral-600 font-normal font-['Work Sans']
                              focus:border focus:border-zinc-800 focus:outline-none focus:ring-0
                              placeholder:text-neutral-400 placeholder:font-normal
                              ${
                                errors?.carimbo?.type === "required" ?
                                "border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                          }
                          `}
                        placeholder={"Observação"}>
                      </textarea>
                      {errors?.carimbo?.type === "required" && (
                        <p className="text-red-500 text-xs whitespace-nowrap">
                          Campo obrigatório
                        </p>
                      )}
                    </div>

                  </div>

                    {requestObject?.request?.isReplica &&
                      <div className="flex gap-2">
                        <input
                          type="checkbox"
                          checked={atualizadoSGRS}
                          onChange={handleAtualizadoSGRSChange}
                          className="form-checkbox h-4 w-4 text-blue-600"
                        />
                        <label className="text-gray-700 font-bold whitespace-nowrap">
                          Confirmo que já atualizei no SGRS
                        </label>
                      </div>
                    }

                    <button
                      disabled={!requestObject?.request?.isReplica ? false : atualizadoSGRS ? false : true}
                      onClick={() => handleSubmit(onSubmit)()}
                      className="w-full bg-blue-500 text-white py-2 px-4 rounded-2xl hover:bg-blue-600 mt-2 disabled:bg-gray-200"
                    >
                      Enviar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
